import adsbridge from './adsbridge.png'
import bemob from './bemob.png'
import binom from './binom.png'
import funnelflux from './funnelflux.png'
import keitaro from './keitaro.png'
import peerclick from './peerclick.png'
import voluum from './voluum.png'
import cpvone from './cpvone.png'

const logos = {
  adsbridge,
  bemob,
  binom,
  funnelflux,
  keitaro,
  peerclick,
  voluum,
  cpvone
}

export default logos
